import { useEffect, useMemo } from "react";
import styles from "./index.module.less";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { getJudgeDetail, getJudgeList } from "../../../services/judge";

import {
  getKsDict,
  getDictIdByCode,
  getDictListById,
} from "@/services/history";
import { findValueByIdAndKey } from "@/utils";
import unKnownJudges from "@/assets/img/unKnownJudges.png";

const JudgeDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [detail, setDetail] = useState({});
  const [moreList, setMoreList] = useState([]);
  const [currentId, setCurrentId] = useState(null);
  const [ksList, setKsList] = useState([]);
  const [zcList, setZcList] = useState([]);

  // 加载评委详情数据
  const loadJudgeDetail = (id) => {
    // 更新浏览器URL，但不刷新页面
    window.history.replaceState(null, "", `/judge/detail?id=${id}`);
    setCurrentId(id);

    // 获取评委详情
    getJudgeDetail(id).then((res) => {
      if (res.code === 200) {
        setDetail(res.result);
      } else {
        setDetail({});
      }
    });

    // 获取其他评委列表
    getJudgeList({
      pageNo: 1,
      pageSize: 10,
      userName: "",
    }).then((res) => {
      if (res.code === 200) {
        let filterResult = res.result.records.filter((item) => item.id !== id);
        // filterResult数组随机截取5个
        if (filterResult && filterResult.length > 5) {
          filterResult = filterResult
            .sort(() => 0.5 - Math.random())
            .slice(0, 5);
        }
        setMoreList(filterResult);
      }
    });
  };

  // 点击其他评委时，直接调用loadJudgeDetail加载数据，不再使用navigate
  const goDetail = (id) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // 判断是否为当前评委ID，如果是，则不处理
    if (id === currentId) {
      return;
    }
    loadJudgeDetail(id);
  };

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };

  const getZcList = async () => {
    const zcList = await getCaseTypeDict("zc");
    setZcList(zcList);
  };

  const zcText = useMemo(() => {
    return findValueByIdAndKey(zcList, detail.experience, "itemText") || "--";
  }, [zcList, detail]);

  const ksText = useMemo(() => {
    return findValueByIdAndKey(ksList, detail.dept, "title", "key") || "--";
  }, [ksList, detail]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id"); // 获取查询参数 id
    if (id) {
      loadJudgeDetail(id);
    }
    getKsDict().then((res) => {
      setKsList(res.result || []);
    });
    getZcList();
  }, []);

  return (
    <div className={styles["judge-detail"]}>
      <div className="judge-detail-title">评委详情</div>

      <div className="judge-detail-content">
        <img src={detail.pic || unKnownJudges} alt="" />
        <div className="judge-detail-info">
          <div className="judge-detail-name">{detail.userName || "-"}</div>
          <div className="judge-detail-dept">
            <div className="judge-detail-job">{ksText}</div>
            <div className="judge-detail-job">{zcText}</div>
          </div>
          <div className="judge-detail-desc">{detail.introduction || "-"}</div>
        </div>
      </div>

      <div className="judge-detail-more">
        <div className="judge-detail-more-title">
          <div className="judge-detail-more-title-left">更多评委</div>
          <div
            className="judge-detail-more-title-right"
            onClick={() => navigate("/judge")}
          >
            查看全部
          </div>
        </div>

        <div className="judge-detail-more-list">
          {moreList.map((item) => {
            return (
              <div key={item.id} onClick={() => goDetail(item.id)}>
                <img src={item.pic || unKnownJudges} alt="" />
                <div>{item.userName || "-"}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default JudgeDetail;
